import type { Article } from "~/api/prismic/types"
import { SliceTypes } from "~/api/prismic/types"

export const getFirstParagraph = (article: Article): string | undefined => {
  let firstParagraph: string | undefined

  article.data.body.some((slice) => {
    if (slice.slice_type === SliceTypes.TEXT) {
      const richText = slice.primary.text[0]

      if (richText && richText.type === "paragraph") {
        firstParagraph = richText.text
      }
    }

    return !!firstParagraph
  })

  return firstParagraph
}
